import script from "./ProgramLayersDesign.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramLayersDesign.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramLayersDesign.vue?vue&type=style&index=0&id=787493d7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-787493d7"]])

export default __exports__